namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.CampaignEligibilityGrid')
    export class CampaignEligibilityGrid extends Serenity.EntityGrid<CampaignEligibilityRow, any> {
        protected getColumnsKey() { return CampaignEligibilityColumns.columnsKey; }
        protected getDialogType() { return CampaignEligibilityDialog; }
        protected getIdProperty() { return CampaignEligibilityRow.idProperty; }
        protected getInsertPermission() { return CampaignEligibilityRow.insertPermission; }
        protected getLocalTextPrefix() { return CampaignEligibilityRow.localTextPrefix; }
        protected getService() { return CampaignEligibilityService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
    }
}